module.exports = __webpack_public_path__ + "img/product.c88fd9fa.png";